import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { loadRuntimeConfig } from "@/lib/runtime-config";
import { installErrorReporter } from "@/lib/error-reporter";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { consumeEntraSSO } from "@/lib/engine-api";

// Fire-and-forget: resolves before any image that uses publicAssetURL tries
// to render, because the first network round-trip to the page itself
// already took 10s of ms.
loadRuntimeConfig();

// Catch all unhandled exceptions (window errors + promise rejections) and POST
// them to /api/client-errors. The root ErrorBoundary below adds React render
// errors. See client/src/lib/error-reporter.ts.
installErrorReporter();

// If we just returned from a Microsoft Entra SSO callback, store the token under
// its tenant slug and redirect to that tenant before React mounts (a full
// navigation, so no chooser flash). No-op when there's no #entra_sso fragment.
consumeEntraSSO();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
